import ERC20_ABI from "./erc20.json";
import ERC20_BYTES32_ABI from "./erc20_bytes32.json";
import GNOSIS_SAFE_ABI from "./gnosis-safe.json";
import GNOSIS_COMPATIBILITY_HANDLER_ABI from "./gnosis-compatibility-fallback-handler.json";
import CHAINLINK_ETH_USD_ABI from "./chainlink-eth-usd.json";

export { ERC20_ABI, ERC20_BYTES32_ABI, GNOSIS_SAFE_ABI, GNOSIS_COMPATIBILITY_HANDLER_ABI, CHAINLINK_ETH_USD_ABI };
